<template>
    <div class="verification-form">
        <div>
            <form class="">
                <div class="row g-4 gx-lg-5 align-items-end">
                    <div v-if="verification.verification" class="col-12">
                        <div class="bd-callout mt-0 bd-callout-warning m-0">
                            <div>
                                <span class="text-muted">Verification: </span> <span>{{ verification.verification.title }}</span>
                            </div>
                             <div>
                                <span  class="text-muted">Deadline: </span> <span>{{ $filters.date(verification.verification.end_at,2) }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <p>You are required to verify your identity by successfully completing the liveness verification process.</p>
                    </div>
                    <div class="col-lg-6">
                        <div class="mb-4">
                            <label class="form-label"> Your National Identification Number (NIN) <span class="text-danger">*</span></label>
                            <input v-if="hashedData.nin" v-model="hashedData.nin" class="form-control"  disabled
                                    type="text" autocomplete="false"  placeholder="NIN" :class="{ 'is-invalid': v$.data.nin.$error }">
                            <input v-else v-model="data.nin" v-maska data-maska="#### ### ####" class="form-control" 
                                    type="text" autocomplete="false"  placeholder="NIN" :class="{ 'is-invalid': v$.data.nin.$error }">
                            
                            <div v-for="(item, index) in v$.data.nin.$errors"
                                :key="index" class="invalid-feedback">
                                <span v-if="item.$message">{{ item.$message }}</span>
                            </div> 
                        </div>

                        <div class="">
                            <label class="form-label"> Your Biometric Verification Number <span class="text-danger">*</span></label>
                            <input v-if="hashedData.bvn" v-model="hashedData.bvn" class="form-control"  disabled
                                    type="text" autocomplete="false"  placeholder="BVN" :class="{ 'is-invalid': v$.data.bvn.$error }">
                            <input v-else v-model="data.bvn" v-maska data-maska="#### ### ####" class="form-control" 
                                    type="text" autocomplete="false"  placeholder="BVN" :class="{ 'is-invalid': v$.data.bvn.$error }">
                            
                            <div v-for="(item, index) in v$.data.bvn.$errors"
                                :key="index" class="invalid-feedback">
                                <span v-if="item.$message">{{ item.$message }}</span>
                            </div> 
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <label class="form-label d-block" for="ProfileImage">Profile photo</label>
                        <div class="d-sm-flex align-items-end">
                            <div class="me-sm-3 mb-3 mb-sm-0">
                                <img v-if="data.image" width="100" class="" :src="absoluteUrl(data.image)"
                                    alt="profile logo" />
                                <svg v-else xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="100"
                                    height="100" viewBox="0 0 256 256" xml:space="preserve">
                                    <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;"
                                        transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                                        <path
                                            d="M 90 90 H 77.615 c -21.744 -5.296 -43.487 -5.296 -65.231 0 H 0 V 0 h 90 V 90 z"
                                            style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(200,209,230); fill-rule: nonzero; opacity: 1;"
                                            transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                        <path
                                            d="M 67.319 68.576 l -4.863 -2.716 c -3.576 -1.997 -6.386 -4.994 -8.161 -8.53 c 2.468 -3.578 4.072 -8.116 4.271 -11.885 h 0.022 l 1.346 -6.015 c 0.298 -1.332 -0.306 -2.604 -1.346 -3.293 v -2.179 c 0 -6.227 -4.193 -13.335 -9.906 -15.582 l 0.009 -0.015 c -2.81 -1.268 -6.633 -1.184 -8.423 -0.718 c 1.849 0.664 2.835 2.557 0.425 3.426 l 0.022 0.001 c -5.402 1.796 -9.302 6.882 -9.302 12.887 v 2.179 c -1.041 0.689 -1.644 1.96 -1.346 3.293 l 1.346 6.015 h 0.022 c 0.199 3.769 1.802 8.307 4.271 11.885 c -1.775 3.536 -4.586 6.533 -8.161 8.53 l -4.863 2.716 c -6.357 3.55 -10.296 10.262 -10.296 17.543 V 90 h 65.231 v -3.881 C 77.615 78.838 73.676 72.126 67.319 68.576 z"
                                            style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(247,247,247); fill-rule: nonzero; opacity: 1;"
                                            transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                    </g>
                                </svg>
                            </div>
                            <div class="">
                                <amazon-liveness-capture ref="livenessCapture" :username="data.first_name"
                                    @livenessSuccess="($event) => { data.image = $event }" />
                            </div>
                        </div>
                        <div v-for="(item, index) in v$.data.image.$errors" :key="index" class="mt-2">
                            <span v-if="item.$message" class="small text-danger">{{ item.$message }}</span>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-check">
                            <input v-model="data.terms_conditions" class="form-check-input" type="checkbox" id="flexCheckDataCollection">
                            <label class="form-check-label" for="flexCheckDataCollection">
                                By checking this box, I confirm that the information provided above is accurate and represents my personal details.
                            </label>
                        </div>
                        <div v-for="(item, index) in v$.data.terms_conditions.$errors" :key="index" class="mt-2">
                            <span v-if="item.$message" class="small text-danger">{{ item.$message }}</span>
                        </div>
                    </div>
                </div>
                <div v-if="errorMessage" class="">
                    <CommonPageErrorMessage :errorMessage="errorMessage"
                        @clearError="() => { errorMessage = null }" />
                </div>
                <div class="mt-4">
                    <div class="d-grid gap-4 d-sm-flex justify-content-sm-between mb-3 mb-sm-0 order-sm-2">
                        <button @click.prevent="confirm()" class="btn btn-primary" type="button">
                            Complete Verification
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>

import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import AmazonLivenessCapture from '@shared/components/forms/AmazonLivenessCapture.vue';


export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components: {
        AmazonLivenessCapture
    },
    props:{
        verification:{
            type: Object,
            default: null
        },
    },
    data() {
        return {
            isLoading: false,
            data: {
                first_name: "",
                image: "",
                nin: "",
                bvn: "",
                terms_conditions: false
            },
            hashedData: {
                nin: "",
                bvn: ""
            },
            mirrorData: null,
            errorMessage: null,
        }
    },
    validations() {
        return {
            data: {
                nin: {
                    exactLength: helpers.withMessage(
                        "NIN must be exactly 11 digits",
                        (value) => (!this.hashedData.nin  ? value.replace(/\s/g, '').length === 11 : true)
                    )
                },
                bvn: {
                    exactLength: helpers.withMessage(
                        "BVN must be exactly 11 digits",
                        (value) => (!this.hashedData.bvn ? value.replace(/\s/g, '').length === 11 : true)
                    )
                },
                image: {
                    required: helpers.withMessage("Profile photo is required", required),
                },
                terms_conditions: { 
                    mustBeTrue: helpers.withMessage(
                        "You must agree that the information provided is true and correct.",
                        (value) => value === true
                    )
                }
            }
        }
    },
    computed:{
      activeUser(){
        return this.$store.state.AppActiveUser;
      },
    },
    methods: {
        async confirm() {
            this.errorMessage = null;
            const result = await this.v$.$validate();
            if (!result) {
                this.alertError(this.v$.$errors[0].$message);
                return;
            }
            const confirmResult = await this.confirmAction({
                html: "<span> Please confirm your data before submitting </span>",
            });
            if (confirmResult.value) {
                this.submitData();
            }
        },
        submitData() {
            let formData = new FormData();
            let data = { ...this.data };
            data.nin = this.$filters.formatAlphanumeric(this.data.nin)
            data.bvn = this.$filters.formatAlphanumeric(this.data.bvn)

            formData.append('data', JSON.stringify(data));
            this.$store.dispatch("changeLoaderValue", true)
            this.$http.post(`/verification-results/${this.verification.friendly_id}/verify`, formData)
                .then((response) => {
                    this.$store.dispatch("changeLoaderValue")
                    if (response.data.success) {
                        this.$emit('completed', response.data.data )
                        this.resetForm()
                    } else {
                        if (response.data.message) { this.errorMessage = response.data.message }
                        this.clearAttachImage(this.errorMessage);
                    }
                })
        },
        async clearAttachImage(message) {

            if (typeof message !== 'string' || !message.trim()) return;
            const msg = message.toLowerCase();
            const keywords = ["image", "file"];
            if (!keywords.some(word => msg.includes(word))) return;

            this.data.image = "";
            this.confirmAction({
                title: "Profile Image Error!",
                html: `<span> ${message}</span>`,
                showCancelButton: false,
                confirmButtonText: "Take Liveness Test Again!"
            }).then((result) => {
                if (result.value && this.$refs.livenessCapture) {
                    this.$refs.livenessCapture.fetchSessionId()
                }
            });
        },
        resetForm() {
            this.data = { ...this.mirrorData }
            this.v$.$reset()
        },
        getOptionData() {
            this.isLoading = false
            this.mirrorData = JSON.parse(JSON.stringify(this.data))
        }
    },
    created() {
        this.getOptionData();
        if(this.activeUser){
            this.data.first_name = this.activeUser.first_name;
        }
        
        if(this.verification && this.verification.employee){
            if(this.verification.employee.nin){
                this.hashedData.nin = this.verification.employee.nin;
            }
            if(this.verification.employee.bvn){
                this.hashedData.bvn = this.verification.employee.bvn;
            }
        }
    }
}
</script>


<style></style>